import styled from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
  min-height: 280px;
  padding-bottom: 200px;
`;

export const CartProductsEmpty = styled.p`
  color: #ececec;
  text-align: center;
  line-height: 40px;
`;
